<template>
    <div class="mh-page">
        <AppHeader title="MH13 Market" back />
        <main class="mh-content">
            <SearchBox v-model="search" placeholder="Search products, stores..." />
            <div class="market-banner">
                <div><small>BIG DISCOUNTS</small>
                    <h1>On Top Categories</h1><button>Shop Now</button>
                </div><span>🛍️</span>
            </div>
            <section class="mh-section">
                <div class="mh-section-head">
                    <h2 class="mh-section-title">Top Categories</h2><span class="mh-link">See All</span>
                </div>
                <div class="mh-grid-2">
                    <CategoryCard v-for="c in categories" :key="c.label" :category="c" />
                </div>
            </section>
            <section class="mh-section">
                <h2 class="mh-section-title">Featured Products</h2>
                <div class="products">
                    <div class="mh-card product" v-for="p in products" :key="p.name">
                        <div>{{ p.icon }}</div><strong>{{ p.name }}</strong><span>{{ p.price }}</span>
                    </div>
                </div>
            </section>
        </main>
        <BottomNavigation />
    </div>
</template>
<script>import AppHeader from "@/components/AppHeader.vue"; import BottomNavigation from "@/components/BottomNavigation.vue"; import SearchBox from "@/components/SearchBox.vue"; import CategoryCard from "@/components/CategoryCard.vue"; export default { name: "MarketView", components: { AppHeader, BottomNavigation, SearchBox, CategoryCard }, data() { return { search: "", categories: [{ label: "Grocery", icon: "🛒" }, { label: "Electronics", icon: "📱" }, { label: "Fashion", icon: "👕" }, { label: "Home", icon: "🪑" }], products: [{ name: "Smartphone", icon: "📱", price: "₹12,999" }, { name: "Motorbike", icon: "🏍️", price: "₹85,000" }, { name: "Fashion Deal", icon: "👗", price: "₹499" }, { name: "Home Needs", icon: "🏠", price: "₹299" }] } } };</script>
<style
    scoped>
    .market-banner {
        min-height: 145px;
        margin-top: 16px;
        padding: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-radius: 18px;
        background: linear-gradient(120deg, #49108b, #ec2f68);
        color: #fff
    }

    .market-banner h1 {
        font-size: 21px
    }

    .market-banner span {
        font-size: 55px
    }

    .market-banner button {
        border: 0;
        border-radius: 7px;
        padding: 7px 12px;
        font-weight: 800
    }

    .products {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 12px;
        margin-top: 12px
    }

    .product {
        padding: 15px
    }

    .product div {
        height: 80px;
        display: grid;
        place-items: center;
        background: #f7f8fa;
        border-radius: 12px;
        font-size: 45px
    }

    .product strong,
    .product span {
        display: block;
        margin-top: 8px
    }

    .product span {
        color: #0a8f4d;
        font-weight: 800
    }
</style>
